<template>
  <div class="modal" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <form @submit.prevent="saveSubLocation">
        <div class="modal-header">
          <h1>Edit sublocation</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="subLocationData.code" ref="inputCode" required>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="subLocationData.name" required>
          </div>
          <div class="mb-3">
            <label for="location_id" class="form-label">Location</label>
            <select class="form-select" id="location_id" v-model="subLocationData.location_id" required>
              <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.name }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel
          </button>
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditSubLocationModal',
  props: {
    subLocation: {
      type: Object,
      required: true,
    },
    locations: {
      type: Array,
      required: true,
    }
  },
  mounted() {
    this.$refs.inputCode.focus();
  },
  data() {
    return {
      subLocationData: {...this.subLocation, location_id: this.subLocation.location.id},
    };
  },
  methods: {
    async saveSubLocation() {
      this.$emit('save-sub-location', this.subLocationData);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>